import { inject, Injector } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MaintenanceService } from '../services/maintenance.service';

export const MaintenanceGuard: CanActivateFn = async () => {
  const injector = inject(Injector);
  const maintenanceService = injector.get(MaintenanceService);
  const router = injector.get(Router);

  try {
    const status = await maintenanceService.getPublicStatus();
    if (status?.isSpaEnabled) {
      router.navigateByUrl('/pre-dashboard');
      return false;
    }
  } catch {
    // If the maintenance check fails, allow navigation — don't block the app
  }

  return true;
};
